import React from "react";
import { Box, Typography } from "@mui/material";
/** @typedef {import("@phosphor-icons/react").Icon} PhosphorIcon */

/**
 * `ModuleHeader` component is a header component for the module.
 * It is used to display the icon, title and subtitle of the module.
 *
 * @param {Object} props - The component props.
 * @param {PhosphorIcon} props.Icon - The icon of the module.
 * @param {React.ReactNode} props.title - The title of the module.
 * @param {React.ReactNode} props.subtitle - The subtitle of the module.
 * @returns {React.ReactNode} The module header component.
 */
const ModuleHeader = ({ title, subtitle, Icon }) => {
  return (
    <Box component="header" data-testid="module-header">
      <Typography
        component="h3"
        variant="h4"
        fontFamily="TestTiemposText"
        data-testid="module-header-title"
      >
        <Icon
          size={24}
          weight="duotone"
          color="#8E42CA"
          style={{ verticalAlign: "sub", marginRight: 8 }}
          data-testid="module-header-icon"
        />
        <span>{title}</span>
      </Typography>

      {subtitle && (
        <Typography
          component="p"
          variant="body2"
          color="text.secondary"
          data-testid="module-header-subtitle"
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default ModuleHeader;
